export default function AboutPage() {
    return null;
}
